module.exports = __webpack_public_path__ + "public/images/slider/speaker-9-icon.1723ea5e22c337502bdd4fc9a6cbce56.jpg";